import React, { useEffect } from "react";
import AOS from "aos";
import "aos/dist/aos.css";
import { Link } from "react-router";

const Service = (props) => {
  useEffect(() => {
    AOS.init();
  }, []);

  return (
    <section id="services" className="services section light-background" >
      <div className="container section-title" data-aos="fade-up">
        <h2> {props?.serviceHeader}</h2>
        <p>
          <b>{props?.description}</b>
        </p>
      </div>
      <div className="container" >
        <div className="row gy-4">
          {props?.services.map((service, index) => (
            <div
              className="col-lg-4 col-md-6"
              data-aos="fade-up"
              data-aos-delay={index * 10} // Delay based on index
              key={index}
            >
              <div className="service-item position-relative" style={{backgroundColor:service?.backgroundColor??""}}>
                <div className="icon">
                  <img
                    src={`assets/img/mServiceLogo/${service.img}`} // Adjust the path as necessary
                    alt={service.label}
                    width="100"
                    height="100"
                  />
                </div>

                {service.link && (
                  <Link to={service.link}>
                    <h3>{service.label}</h3>
                  </Link>
                )}

                <div>
                  <h3>{service.totalDescription}.</h3>
                  {/* You can add a description here if needed */}
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Service;
